/**
 * Main Store
 * 공통으로 사용될 요소
 *
 * @since 2017-12-12
 * @author kdydesign.kim
 */
import {i18n} from '~/plugins/i18n'
// json file
// Prism, 추후 변경 필요 (서버연동)
// import {clientMenu} from '~/static/clientMenu.json'

// utils
import {clientDate, formatDate} from '../../utils/date'
import {pcDownloadFile} from '../../utils/files'

const getFlattenMenu = (menu) => {
  return _.flatten(_.map(menu, depth => {
    if (_.has(depth, 'children')) {
      return getFlattenMenu(depth.children)
    } else {
      return depth
    }
  }))
}

export const state = () => ({
  menu: void 0,
  flatMenu: void 0,
  clientMenu: void 0,
  thisMenuCode: 0,
  thisMenuPath: '/',
  homePath: '/',
  authAlarm: false,
  authSync: false,
  authSyncConfig: false,
  ticketEvent: false,
  menuFold: {}
})

export const mutations = {
  // 메뉴 조회
  getMenu (state, data) {
    state.menu = data
  },
  setMenu (state, { menu, user }) {
    if (_.size(menu) > 0) {
      const flatMenu = getFlattenMenu(menu)

      let storageData = localStorage.getItem('custom_user_settings')
      if (storageData === null) {
        localStorage.setItem('custom_user_settings', JSON.stringify({}))
        storageData = localStorage.getItem('custom_user_settings')
      }

      const customSettings = JSON.parse(storageData)

      if (!_.isEmpty(customSettings)) {
        const admId = user.adm_id.toString()
        if (typeof _.get(customSettings, [admId, 'menu']) !== 'undefined') {
          state.menuFold = customSettings[admId].menu
        } else {
          state.menuFold = {}
        }
      } else {
        state.menuFold = {}
      }
      state.menu = menu
      state.flatMenu = flatMenu
    } else {
      state.menu = []
      state.flatMenu = []
      state.menuFold = {}
    }
  },
  getClientMenu (state, data) {
    state.clientMenu = data
  },
  setHomePath (state, homePath) {
    state.homePath = homePath
  },
  setClientMenu (state, clientMenu) {
    state.clientMenu = clientMenu
  },
  setAuthAlarm (state, payload = false) {
    state.authAlarm = payload
  },
  setAuthSync (state, payload = false) {
    state.authSync = payload
  },
  setAuthSyncConfig (state, payload = false) {
    state.authSyncConfig = payload
  },
  setTicketEvent (state, payload = false) {
    state.ticketEvent = payload
  },
  setMenuFold (state, payload) {
    state.menuFold = payload
  }
}

export const actions = {
  async getMenu ({ state, commit }) {
    if (state.menu !== undefined) {
      return
    }
    const { result } = await this.$axios.$get('/api/sm/menu', {
      successAlert: false,
      loading: false,
      ignoreHaPrefix: true
    })

    commit('setMenu', result.menu)
  },
  async execMfxMgmt () {
    const apiUri = '/api/sm/mfxmgmt-login'
    const res = await this.$axios.$file(apiUri, void 0, {
      responseType: 'arraybuffer', // MF Series 에러 리턴 시를 위함
      method: 'post',
      successAlert: false,
      ignoreHaPrefix: true
    })

    if (typeof res.fileName !== 'undefined') {
      const { data, fileName } = res
      pcDownloadFile(data, fileName)
    }
    return res
  },
  async reqMenuFold ({commit, rootState}, {code, isOpen}) {
    try {
      // TAMS (각 계정별 localStorage 설정 값으로 대체)
      const admId = rootState.common.common.uiData.user.adm_id

      let storageData = localStorage.getItem('custom_user_settings')
      if (storageData === null) {
        localStorage.setItem('custom_user_settings', JSON.stringify({}))
        storageData = localStorage.getItem('custom_user_settings')
      }

      const customSettings = JSON.parse(storageData)

      const customIsOpen = _.get(customSettings, [admId, 'menu', code, 'isOpen'])
      if (typeof customIsOpen !== 'undefined') {
        customSettings[admId].menu[code].isOpen = isOpen
      } else {
        _.setWith(customSettings, [admId, 'menu', code, 'isOpen'], isOpen, Object)
      }

      localStorage.setItem('custom_user_settings', JSON.stringify(customSettings))
      commit('setMenuFold', customSettings[admId].menu)
    } catch (e) {
      return false
    }
  }
}

export const getters = {
  clientMenu (state, getters, rootState) {
    const
      // authUser = rootState.common.authenticate.authUser, // TAMS
      authUser = rootState.common.common.authUser, // NGF
      uiData = rootState.common.common.uiData

    let
      connectTime = clientDate('HH:mm:ss'),
      connectDate = clientDate('YYYY-MM-DD HH:mm:ss')

    if (authUser) {
      if (uiData) {
        const currentTime = uiData.system.current_time

        connectTime = formatDate(currentTime, 'HH:mm:ss')
        connectDate = formatDate(currentTime, 'YYYY-MM-DD HH:mm:ss')
      }

      const cm = _.map(state.clientMenu, (cmo) => {
        if (cmo.key === 'connUser') {
          cmo.name = `${authUser.login_id}<br>${connectTime}` // NGF

          _.map(cmo.children, (cmoc) => {
            if (cmoc.key === 'manager') {
              cmoc.name = `${i18n.t('cmn.manager')} : ${authUser.login_id}` // NGF
            }

            if (cmoc.key === 'connTime') {
              cmoc.name = `${i18n.t('cmn.loginTime')} : ${connectDate}`
            }

            return cmoc
          })
        }

        return cmo
      })

      return cm
    }

    return state.clientMenu
  },
  menu (state) {
    return state.menu
  },
  getFlattenMenu (state) {
    return _.flatten(_.map(state.menu, (dept1Menu) => {
      return _.flatten(_.map(dept1Menu.children, (dept2Menu) => {
        return _.flatten(_.map(dept2Menu.children, (dept3Menu) => {
          if (_.has(dept3Menu, 'children')) {
            return _.flatten(_.map(dept3Menu.children, (dept4Menu) => {
              const disableFlag = false
              return _.assign(dept4Menu, {
                label: `${dept2Menu.name} > ${dept4Menu.name}`,
                route: `${dept1Menu.key}/${dept2Menu.key}/${dept3Menu.key}/${dept4Menu.key}`,
                disable: disableFlag
              })
            }))
          } else {
            const routePath = `${dept1Menu.key}/${dept2Menu.key}/${dept3Menu.key}`
            return _.assign(dept3Menu, {
              label: `${dept2Menu.name} > ${dept3Menu.name}`,
              route: routePath
            })
          }
        }))
      }))
    }))
  }
}

export const strict = false
